import { useEffect, Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Home from "@/pages/Home";

const Admin = lazy(() => import("@/pages/Admin"));
const SoraSushi = lazy(() => import("@/pages/demos/SoraSushi"));
const VerdantLandscapes = lazy(() => import("@/pages/demos/VerdantLandscapes"));
const SparkleShine = lazy(() => import("@/pages/demos/SparkleShine"));

const RouteLoader = () => (
  <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{ width: '40px', height: '40px', border: '2px solid #C9C3B6', borderTop: '2px solid #4A443B', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto', marginBottom: '1rem' }}></div>
      <p style={{ color: '#1C1917', opacity: 0.6 }}>Loading...</p>
    </div>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="bottom-right" theme="dark" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/demos/sora-sushi" element={<Suspense fallback={<RouteLoader />}><SoraSushi /></Suspense>} />
          <Route path="/demos/verdant-landscapes" element={<Suspense fallback={<RouteLoader />}><VerdantLandscapes /></Suspense>} />
          <Route path="/demos/sparkle-shine" element={<Suspense fallback={<RouteLoader />}><SparkleShine /></Suspense>} />
          <Route path="/admin" element={<Suspense fallback={<RouteLoader />}><Admin /></Suspense>} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
